import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import type { User } from '@shared/api.interface';
import '@client/src/api/axios';

interface AuthState {
  user: User | null;
  token: string | null;
  isAuthenticated: boolean;
  hasHydrated: boolean;
  login: (token: string, user: User) => void;
  logout: () => void;
  setUser: (user: User) => void;
  _setHasHydrated: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, _get, store) => ({
      user: null,
      token: null,
      isAuthenticated: false,
      hasHydrated: false,
      login: (token: string, user: User) =>
        set({ token, user, isAuthenticated: true }),
      logout: () => set({ token: null, user: null, isAuthenticated: false }),
      setUser: (user: User) => set({ user }),
      _setHasHydrated: () => set({ hasHydrated: true }),
    }),
    {
      name: 'studio-auth-storage',
      // 用sessionStorage：每个标签页独立，管理端和陪玩端同时开不会互相覆盖
      storage: createJSONStorage(() => sessionStorage),
      onRehydrateStorage: () => (state) => {
        state?._setHasHydrated();
      },
    }
  )
);
